import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { ICompany, IInspectionChecklist } from '~/utils/types'

export const useChecklistValue = () => {
  const { t } = useTranslation()

  const formatChecklistDisplay = useMemo(
    () => (item: IInspectionChecklist) => {
      const customer = item.customer as ICompany
      if (!customer?.name) return item.description
      const checklistValue = `${customer.name} - ${item.description}`.trim()
      if (checklistValue?.length > 128) {
        return checklistValue.substring(0, 125) + '...'
      }
      return checklistValue
    },
    []
  )

  const groupChecklists = useMemo(
    () => (generic: IInspectionChecklist[], specific: IInspectionChecklist[]) => {
      const groups = []
      if (specific.length > 0) {
        groups.push({
          group: t('Specific Checklists'),
          options: specific,
        })
      }
      if (generic.length > 0) {
        groups.push({
          group: t('Generic Checklists'),
          options: generic,
        })
      }
      return groups
    },
    [t]
  )

  return {
    formatChecklistDisplay,
    groupChecklists,
  }
}
